/**
 * V1 is just monitoring for changes in filters.  In the future this component could also track things like global
 * click/mouse tracking, time on page, or events  that don't have a specific component to track them.
 */

import { useEnqueueEngagement } from '../hooks';
import { useEffect } from 'react';
import { ACTION_TYPE } from 'rwl-shared/dist/models/EngagementEvent';
import { useFilter } from 'rwl-ui';

export const EngagementMonitor = (): null => {
    const { setAfterFilterChangeHandler } = useFilter();
    const { enqueue } = useEnqueueEngagement();

    useEffect(() => {
        setAfterFilterChangeHandler(({ action, filterID }) => {
            if (action === 'add') {
                enqueue({
                    actionType: ACTION_TYPE.CLICK,
                    type: 'Engagement',
                    target: 'Filter Applied',
                    filter: filterID,
                });
            }
        });

        return () => {
            setAfterFilterChangeHandler(() => void 0);
        };
    }, [enqueue]);

    return null;
};
